"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Wishlist32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M28.685 13.035c-.089.4-.224.781-.4 1.133a6.68 6.68 0 01-.677 1.088 4.658 4.658 0 01-.82.837l-10.776 9.045L5.2 16.062a4.516 4.516 0 01-.784-.807 6.749 6.749 0 01-.677-1.088 5.023 5.023 0 01-.4-1.133 6.281 6.281 0 01-.139-1.348c0-.779.143-1.496.436-2.191a5.064 5.064 0 011.228-1.769 6.063 6.063 0 011.867-1.275 5.211 5.211 0 012.156-.452c.581 0 1.131.088 1.68.272a5.638 5.638 0 011.524.767 5.592 5.592 0 012.072 2.534 1.999 1.999 0 003.698 0 5.607 5.607 0 012.073-2.534 6.796 6.796 0 011.569-.772 5.26 5.26 0 013.805.179 6.33 6.33 0 011.895 1.324 4.95 4.95 0 011.184 1.727c.293.695.436 1.412.436 2.191 0 .477-.047.931-.139 1.348zm1.546-4.316a7.014 7.014 0 00-1.656-2.407 8.258 8.258 0 00-2.437-1.688c-.917-.416-1.917-.624-3-.624-.792 0-1.552.124-2.281.375a8.73 8.73 0 00-2.032 1 7.592 7.592 0 00-2.812 3.437 7.575 7.575 0 00-2.812-3.437 7.476 7.476 0 00-2-1A7.244 7.244 0 008.888 4a7.236 7.236 0 00-2.968.624 8.14 8.14 0 00-2.469 1.688c-.708.667-1.26 1.469-1.656 2.407s-.593 1.927-.593 2.968c0 .625.063 1.219.187 1.781.125.563.313 1.095.563 1.595.251.5.541.968.875 1.405s.709.823 1.125 1.156l12.063 10.125 12.063-10.125c.416-.333.792-.719 1.125-1.156s.624-.905.875-1.405c.249-.5.437-1.032.563-1.595s.187-1.156.187-1.781a7.548 7.548 0 00-.593-2.968z" }))); };
var StyledWishlist32 = styled_components_1.default(Wishlist32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledWishlist32;
var templateObject_1;
//# sourceMappingURL=Wishlist32.js.map